import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Card from '../components/card/Card';
import H from '../components/texts/h/H';
import P from '../components/texts/p/P';
import Spinner from '../components/Spinner/spinner';
import MonetizationForm from '../components/monetization/MonetizationForm';
import { routes } from '../routes/routePaths';

export interface PrefilledData {
  cuit: string;
  companyName: string;
  productId: number;
  productLineCode: string;
  productLabel: string;
  currencyId: number;
  currencyCode: string;
  effectiveCapacity: number;
  availableOperable: number;
  availableProduct: number;
  availableCuitCurrency: number;
  applicationProductLineId: number | null;
}

const MonetizationNewPrefilled = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [prefilledData, setPrefilledData] = useState<PrefilledData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const isPrefilled = searchParams.get('prefilled') === 'true';
    
    if (!isPrefilled) {
      navigate(routes.monetization);
      return;
    }

    const cuit = searchParams.get('cuit');
    const companyName = searchParams.get('companyName');
    const productId = searchParams.get('productId');
    const productLineCode = searchParams.get('productLineCode');
    const productLabel = searchParams.get('productLabel');
    const currencyId = searchParams.get('currencyId');
    const currencyCode = searchParams.get('currencyCode');
    const effectiveCapacity = searchParams.get('effectiveCapacity');
    const availableOperable = searchParams.get('availableOperable');
    const availableProduct = searchParams.get('availableProduct');
    const availableCuitCurrency = searchParams.get('availableCuitCurrency');
    const applicationProductLineId = searchParams.get('applicationProductLineId');

    if (!cuit || !productId || !currencyId || !productLabel || !productLineCode) {
      setError('Faltan parámetros requeridos. Por favor, volvé a iniciar el proceso.');
      return;
    }

    setPrefilledData({
      cuit,
      companyName: companyName || '',
      productId: parseInt(productId, 10),
      productLineCode,
      productLabel,
      currencyId: parseInt(currencyId, 10),
      currencyCode: currencyCode || 'ARS',
      effectiveCapacity: parseFloat(effectiveCapacity || '0'),
      availableOperable: parseFloat(availableOperable || effectiveCapacity || '0'),
      availableProduct: parseFloat(availableProduct || '0'),
      availableCuitCurrency: parseFloat(availableCuitCurrency || '0'),
      applicationProductLineId: applicationProductLineId ? parseInt(applicationProductLineId, 10) : null,
    });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Card variant='neutral' modifier='inverted' spacing={'4'} height='-webkit-fill-available' width='85vw'>
        <Card display='flex' flexDirection='column' justifyContent='center' alignItems='center' height='300px'>
          <H type="1" weight="regular" modifier="weak">{error}</H>
          <Card margin={{ top: '4' }}>
            <a href={routes.monetization} style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>
              Volver a Monetización
            </a>
          </Card>
        </Card>
      </Card>
    );
  }

  if (!prefilledData) {
    return (
      <Card variant='neutral' modifier='inverted' spacing={'4'} height='-webkit-fill-available' width='85vw'>
        <Card display='flex' justifyContent='center' alignItems='center' height='300px'>
          <Spinner size='lg' variant='primary' />
        </Card>
      </Card>
    );
  }

  return (
    <MonetizationForm 
      mode="create" 
      prefilledMode={true}
      prefilledData={prefilledData}
    />
  );
};

export default MonetizationNewPrefilled;
